import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['toggleable', 'icon']
  static values = { open: Boolean }

  declare toggleableTargets: HTMLElement[]
  declare iconTargets: HTMLElement[]
  declare openValue: boolean

  connect (): void {
    this.openValue = true
    this.toggleVisibility()
  }

  toggle (): void {
    this.openValue = !this.openValue
    this.toggleVisibility()
  }

  toggleVisibility (): void {
    this.toggleableTargets.forEach((el: HTMLElement) => {
      el.classList.toggle('hidden', !this.openValue)
    })

    this.iconTargets.forEach((wrapper: HTMLElement) => {
      const openIcon = wrapper.querySelector('[data-icon-state="open"]')
      const closedIcon = wrapper.querySelector('[data-icon-state="closed"]')

      if ((openIcon != null) && (closedIcon != null)) {
        if (this.openValue) {
          openIcon.classList.remove('hidden')
          closedIcon.classList.add('hidden')
        } else {
          openIcon.classList.add('hidden')
          closedIcon.classList.remove('hidden')
        }
      }
    })
  }
}
